export default __webpack_public_path__ + "static/media/轮播首图9.6bc54cb0.jpg";